





















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import MyForm from "@/mixins/form";
import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() customerId!: number;
  @Prop() stadiumId!: number;
  @Prop() userId!: number;
  @Prop() mobile!: string;
  stadiumIds: any[] = [];

  stadiumPermissions: any[] = [];

  perms: string[] = [];

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (moment.isMoment(fieldValue)) {
                  _.set(
                    values,
                    [key],
                    moment(fieldValue).format("YYYY-MM-DD HH:mm:ss")
                  );
                } else if (_.startsWith(key, "perm_")) {
                  _.set(values, [key], fieldValue ? 1 : "x");
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }
            const res = await this.$store.dispatch("admin/editTaisamAccount", {
              customer_id: this.customerId,
              stadium_id: this.stadiumId,
              id: this.editId,
              ...values,
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("stadium/getAccount", {
      customer_id: this.customerId,
      stadium_id: this.stadiumId,
      id: this.editId,
    });
    if (res && res.Data && res.Data !== "{}") {
      this.formData = res.Data;
    }

    const res2 = await this.$store.dispatch("stadium/permissions", {
      customer_id: this.customerId,
      stadium_id: this.stadiumId,
    });
    // console.log(res2);
    if (res2 && res2.Data) {
      // console.log(JSON.parse(res1.data));
      this.stadiumPermissions = res2.Data;
    }

    this.spinLoading = false;
  }
}
